export default __webpack_public_path__ + "static/media/man.27b0ce7d.svg";